import React from 'react';
import { CustomActionCell } from '../../index';
import { QuestionCircleIcon } from '../../icon/solid';
import useStyles from './styles';

type Props = {
  title: string;
  tooltip: string;
  className?: string;
  iconClassName?: string;
};

const StepModalCaption = ({
  title, tooltip, className, iconClassName,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={`${classes.text} ${className}`}>{title}</span>
      <CustomActionCell
        title={<QuestionCircleIcon className={`${classes.icon} ${iconClassName}`} />}
        classNameButtonWrapper={classes.commentButtonWrapper}
        onMouse
      >
        <p className={classes.comment}>
          {tooltip}
        </p>
      </CustomActionCell>
    </div>

  );
};

export default StepModalCaption;
